import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Vehicle maintenances stats DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE_MAINTENANCE)
export class VehicleMaintenancesStatsDto extends BaseStatsDto {
  pending!: number;
  approved!: number;
  rejected!: number;
  scheduled!: number;
  inProgress!: number;
  completed!: number;
}
